import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SectionHeading, Reveal } from "@/components/Primitives";
import api, { rupee } from "@/lib/api";
import { Check, Star } from "lucide-react";

export default function Packages() {
  const [pkgs, setPkgs] = useState([]);
  useEffect(() => { api.get("/public/packages").then((r) => setPkgs(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <SectionHeading eyebrow="Packages" title="Transparent, flexible packages"
        subtitle="Clear pricing with no hidden promises. Domain, hosting and third-party costs are billed at actual cost." />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
        {pkgs.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08}>
            <div className={`glass rounded-3xl p-8 card-hover h-full relative ${p.slug === "business" ? "border-violet-500/50 ring-1 ring-violet-500/30" : ""}`} data-testid={`package-card-${p.slug}`}>
              {p.slug === "business" && <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-xs font-semibold bg-violet-600 text-white px-3 py-1 rounded-full flex items-center gap-1"><Star className="w-3 h-3" />Most popular</span>}
              <h3 className="font-display text-2xl font-bold text-white">{p.name}</h3>
              <div className="mt-4 mb-2">
                {p.price_rupees ? (
                  <div><span className="font-display text-4xl font-extrabold text-gradient">{rupee(p.price_rupees)}</span><span className="text-slate-400 text-sm"> setup</span></div>
                ) : (
                  <Link to="/contact"><span className="font-display text-2xl font-bold text-white">Request Quote</span></Link>
                )}
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-400 mb-5">
                <span>{p.revisions} revisions</span><span>•</span><span>{p.delivery_time}</span>
              </div>
              <div className="text-xs font-mono uppercase text-violet-300 mb-2">Includes</div>
              <ul className="space-y-2 mb-5">
                {(p.features || []).map((f) => (<li key={f} className="flex gap-2 text-sm text-slate-200"><Check className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />{f}</li>))}
              </ul>
              <div className="text-xs text-slate-500 space-y-1 border-t border-white/10 pt-4 mb-6">
                <div>Pages: {(p.pages || []).join(", ")}</div>
                <div>Maintenance: {p.maintenance}</div>
                <div>Domain & hosting: {p.domain_hosting}</div>
                <div>Renewal: {p.renewal_terms}</div>
                <div>Taxes: {p.taxes}</div>
              </div>
              <Link to={`/contact?package=${p.slug}`}>
                <Button data-testid={`package-cta-${p.slug}`} className={`w-full ${p.slug === "business" ? "bg-violet-600 hover:bg-violet-500" : "bg-white/10 hover:bg-white/15"} text-white font-semibold`}>Get Started</Button>
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="text-center text-xs text-slate-500 mt-10 max-w-2xl mx-auto">We don't offer lifetime free hosting or unlimited support. Hosting and domains renew annually at provider rates. All prices are editable and may change — confirm your final quote with us.</p>
    </div>
  );
}
